import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { cloudChiprApi } from "@/services/cloudchipr.api";
import { dimensionSharedCostsSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsSelector";
import { dimensionSharedCostsDataSelector } from "@/store/dimensions/selectors/shared-costs/dimensionSharedCostsDataSelector";
import { convertSharedCostsArrayToObjectByIds } from "@/store/dimensions/thunks/dimensions/update-current-dimension/shared-costs/convertSharedCostsArrayToObjectByIds";

export const findAndDeleteRemovedSharedCostsThunk = createAsyncThunk(
  "dimensions/findAndDeleteRemovedSharedCosts",
  async (dimensionId: string, { dispatch, getState }) => {
    const state = getState() as RootState;
    const dimensionSharedCosts = dimensionSharedCostsSelector(state);
    const dimensionSharedCostsObject =
      convertSharedCostsArrayToObjectByIds(dimensionSharedCosts);

    const originalSharedCosts = dimensionSharedCostsDataSelector(state);

    if (!originalSharedCosts || !dimensionId) {
      return;
    }

    const removedSharedCosts = originalSharedCosts.filter((sharedCost) => {
      return !dimensionSharedCostsObject[sharedCost.id];
    });

    removedSharedCosts.forEach((sharedCost) => {
      dispatch(
        cloudChiprApi.endpoints.deleteUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostId.initiate(
          {
            dimensionId,
            sharedCostId: sharedCost.id,
          },
        ),
      );
    });
  },
);
